import { Injectable } from '@angular/core';
import { PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner } from 'src/sdk_checkin';

@Injectable({
  providedIn: 'root',
})
export class CheckinPassengerInputPassportService {
  constructor() {}

  /**
   * セグメント情報IDリストに紐づくパスポート情報を、重複する要素を取り除いて返す。
   *
   * @param passports パスポート情報
   * @param flightIds セグメント情報IDリスト
   * @param isMasking マスキングの有無
   * @returns セグメント情報IDリストに紐づくパスポート情報
   */
  getLinkedPassportsToJourney(
    passports: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner[] | undefined,
    flightIds: string[] | undefined,
    isMasking: boolean
  ) {
    if (!passports || !flightIds) {
      return undefined;
    }

    // パスポート情報をflightIdで抽出
    const checkFlightId = (flightId?: string, flightIds?: string[]) => !flightId || flightIds?.includes(flightId);
    let filterdPassports = passports?.filter((passport) => checkFlightId(passport.flightId, flightIds));

    // パスポート情報の重複の削除
    let passportsNoDuplicate:
      | PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner[]
      | undefined;
    if (filterdPassports?.length) {
      // マスキング要否によって、重複していると判断するための関数を変更
      const checkDuplicate = isMasking
        ? (
            passport1: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner,
            passport2: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner
          ) =>
            passport1.name?.firstName === passport2.name?.firstName &&
            passport1.name?.middleName === passport2.name?.middleName &&
            passport1.name?.lastName === passport2.name?.lastName &&
            passport1.encryptedBirthDate === passport2.encryptedBirthDate &&
            passport1.gender === passport2.gender &&
            passport1.nationalityCode === passport2.nationalityCode &&
            passport1.encryptedNumber === passport2.encryptedNumber &&
            passport1.expiryDate === passport2.expiryDate &&
            passport1.issuanceCountryCode === passport2.issuanceCountryCode
        : (
            passport1: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner,
            passport2: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner
          ) =>
            passport1.name?.firstName === passport2.name?.firstName &&
            passport1.name?.middleName === passport2.name?.middleName &&
            passport1.name?.lastName === passport2.name?.lastName &&
            passport1.birthDate === passport2.birthDate &&
            passport1.gender === passport2.gender &&
            passport1.nationalityCode === passport2.nationalityCode &&
            passport1.number === passport2.number &&
            passport1.expiryDate === passport2.expiryDate &&
            passport1.issuanceCountryCode === passport2.issuanceCountryCode;

      passportsNoDuplicate = filterdPassports?.reduce(
        (
          passports: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner[],
          passport: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner
        ) => {
          const isDuplicate = passports.find(
            (compPassports: PostJourneysGetJourneyResponseDataTravelersInnerRegulatoryDetailsPassportsInner) =>
              checkDuplicate(passport, compPassports)
          );
          if (!isDuplicate) {
            return passports.concat([passport]);
          }
          return passports;
        },
        []
      );
    }
    return passportsNoDuplicate?.length ? passportsNoDuplicate : undefined;
  }
}
